import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell
} from 'recharts';
import GlassCard from '@/components/base/GlassCard';
import KpiCard from '@/components/base/KpiCard';
import { scoringCriteria, scoreDistribution, topScoredExperts } from '@/mocks/dashboardData';

const ScoringPage: React.FC = () => {
  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Uzman Skorlama & Kalite Analizi</h1>
        <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>Puan kriterleri ve kalite dağılımı</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5">
        <KpiCard label="Ortalama Skor" value="4.3" change={0.8} icon="ri-star-line" suffix="/5" />
        <KpiCard label="4+ Skorlu Uzman" value={210} change={5.2} icon="ri-award-line" />
        <KpiCard label="Red Oranı" value={65} change={-2.1} icon="ri-close-circle-line" suffix="%" />
        <KpiCard label="Profil Tamamlama" value={78} change={3.4} icon="ri-user-settings-line" suffix="%" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <GlassCard title="Skor Dağılımı" subtitle="Uzman skor histogram">
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={scoreDistribution}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
              <XAxis dataKey="aralik" tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fill: '#6b7280', fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ background: '#1a1a2e', border: '1px solid rgba(255,77,77,0.3)', borderRadius: '8px', fontSize: '12px' }} />
              <Bar dataKey="sayi" name="Uzman Sayısı" radius={[4, 4, 0, 0]}>
                {scoreDistribution.map((_, i) => (
                  <Cell key={i} fill={`hsl(${10 + i * 15}, 90%, ${50 + i * 4}%)`} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </GlassCard>

        <GlassCard title="Puan Kriterleri & Ağırlıklar" subtitle="Skor hesaplama bileşenleri">
          <div className="space-y-2.5">
            {scoringCriteria.map((c) => (
              <div key={c.kriter}>
                <div className="flex justify-between text-xs mb-1">
                  <span style={{ color: '#d1d5db' }}>{c.kriter}</span>
                  <span style={{ color: '#ff8c42' }}>%{c.agirlik}</span>
                </div>
                <div className="h-1.5 rounded-full" style={{ background: 'rgba(255,255,255,0.08)' }}>
                  <div
                    className="h-1.5 rounded-full transition-all duration-700"
                    style={{
                      width: `${c.agirlik * 5}%`,
                      background: 'linear-gradient(90deg, #ff4d4d, #ff8c42)',
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </GlassCard>
      </div>

      <GlassCard title="En Yüksek Skorlu Uzmanlar" subtitle="Top 5">
        <div className="space-y-3">
          {topScoredExperts.map((expert, idx) => (
            <div key={expert.isim} className="flex items-center gap-3 p-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)' }}>
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                style={{ background: idx === 0 ? 'linear-gradient(135deg,#ffd700,#ffaa00)' : idx === 1 ? 'linear-gradient(135deg,#c0c0c0,#909090)' : idx === 2 ? 'linear-gradient(135deg,#cd7f32,#a05a00)' : 'linear-gradient(135deg,#ff4d4d,#ff8c42)' }}
              >
                {idx + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-white">{expert.isim}</div>
                <div className="text-xs" style={{ color: '#6b7280' }}>{expert.sehir} · {expert.is} iş</div>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-xs" style={{ color: '#ff8c42' }}></i>
                <span className="text-white font-bold text-sm">{expert.skor}</span>
              </div>
            </div>
          ))}
        </div>
      </GlassCard>
    </div>
  );
};

export default ScoringPage;
